import React from "react";
import { View } from "react-native";

export default function Cover() {
  return <View style={{ flex: 1 }} />;
}
